import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

/**
 * Deep-merge two plain objects. Nested objects are merged; primitives and arrays are overwritten.
 */
function deepMerge (target, source) {
  const result = { ...target }
  for (const key of Object.keys(source)) {
    if (
      source[key] &&
      typeof source[key] === 'object' &&
      !Array.isArray(source[key]) &&
      target[key] &&
      typeof target[key] === 'object' &&
      !Array.isArray(target[key])
    ) {
      result[key] = deepMerge(target[key], source[key])
    } else {
      result[key] = source[key]
    }
  }
  return result
}

/**
 * Load all locale JSON files from ./locales (including subdirectories like mypages/).
 * Files are grouped by locale using the filename before .json (e.g. en.json, mypages/en.json → both merged into "en").
 */
function loadLocaleMessages () {
  const locales = require.context('./locales', true, /\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const match = key.match(/([A-Za-z0-9-_]+)\.json$/i)
    if (match) {
      const locale = match[1].toLowerCase()
      const content = locales(key)
      if (!messages[locale]) {
        messages[locale] = {}
      }
      messages[locale] = deepMerge(messages[locale], content)
    }
  })
  return messages
}

export default new VueI18n({
  locale: localStorage.getItem('lang') || process.env.VUE_APP_I18N_LOCALE || 'lv',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages()
})
